import { render, staticRenderFns } from "./CreateByType.vue?vue&type=template&id=1cf62c14&"
var script = {}
import style0 from "./CreateByType.vue?vue&type=style&index=0&id=1cf62c14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports